/* */ 
var Iterators = require('./_iterators');
var ITERATOR = require('./_wks')('iterator');
var ArrayProto = Array.prototype;
module.exports = function(it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};
